import { gql } from '@apollo/client'
import { LabelFragment } from './labels'

export const ClipLabelFragment = gql`
  fragment ClipLabelFragment on ClipLabel {
    id
    createdAt
    updatedAt
    label {
      ...LabelFragment
    }
  }
  ${LabelFragment}
`
